import { AuthService } from "./../services/auth.service";
import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-modal-user-config",
  templateUrl: "./modal-user-config.component.html",
  styleUrls: ["./modal-user-config.component.scss"],
})
export class ModalUserConfigComponent implements OnInit {
  form: FormGroup;

  constructor(private fb: FormBuilder, private authService: AuthService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      Senha: ["", [Validators.required]],
      NovaSenha: ["", [Validators.required, Validators.minLength(6)]],
      ConfirmarSenha: ["", [Validators.required, this.validateConfirmarSenha]],
    });
  }

  validateConfirmarSenha = (confirmarSenha: AbstractControl) => {
    if (
      this.form &&
      this.form.get("NovaSenha").value !== confirmarSenha.value
    ) {
      return { senhasDiferentes: true };
    }
    return null;
  };

  trocarSenha() {
    console.log(this.form.value);
    this.authService.trocarSenha(
      this.form.value.Senha,
      this.form.value.NovaSenha
    );
  }
}
